import CheckboxField from "@/components/CheckboxField";
import { useDictionaryContext } from "@/components/dictionaries/DictionaryContext";
import DictionaryForm from "@/components/dictionaries/DictionaryForm";
import Field from "@/components/Field";
import Fieldset from "@/components/Fieldset";
import PageContent from "@/components/PageContent";
import TimeInput from "@/components/TimeInput";
import { Input } from "@/components/ui/input";
import { isRequired } from "@/lib/form";
import { useShiftDictionary } from "@/modules/shifts/hooks/useShiftDictionary";
import { useTranslation } from "react-i18next";
import SaveButton from "@/components/SaveButton";

export default function ShiftForm() {
  const { t } = useTranslation();
  const config = useShiftDictionary();
  const { Icon, ns } = config;
  const labels = config.getLabels(t);
  const { mutation } = useDictionaryContext();

  return (
    <DictionaryForm>
      <PageContent
        icon={<Icon className="w-6 h-6 mr-3" />}
        title={labels.title}
        footer={<SaveButton />}
      >
        <Fieldset className="flex flex-row max-w-2xl">
          <Field
            name="name"
            wrapperClassName="flex flex-1"
            className="flex flex-1"
            label={t(`${ns}.fields.name`)}
            required={isRequired(config.schema.shape.name)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
          <CheckboxField
            name="mandatory"
            label={t(`${ns}.fields.mandatory`)}
            required={isRequired(config.schema.shape.mandatory)}
            disabled={mutation.isPending}
          />
        </Fieldset>
        <Fieldset className="flex flex-row">
          <Field
            name="shift_begin"
            label={t(`${ns}.fields.shift_begin`)}
            required={isRequired(config.schema.shape.shift_begin)}
            render={({ field }) => (
              <TimeInput disabled={mutation.isPending} {...field} />
            )}
          />
          <Field
            name="shift_end"
            label={t(`${ns}.fields.shift_end`)}
            required={isRequired(config.schema.shape.shift_end)}
            render={({ field }) => (
              <TimeInput disabled={mutation.isPending} {...field} />
            )}
          />
        </Fieldset>
        <Fieldset className="max-w-2xl">
          <Field
            name="description"
            wrapperClassName="flex flex-1"
            className="flex flex-1"
            label={t(`${ns}.fields.description`)}
            required={isRequired(config.schema.shape.description)}
            render={({ field }) => (
              <Input
                disabled={mutation.isPending}
                className="w-full"
                {...field}
              />
            )}
          />
        </Fieldset>
      </PageContent>
    </DictionaryForm>
  );
}
